import Controller from '@ember/controller';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';
import { ApplicationFlowUpdate } from '@square/dashboard-protos/models/squareup/sfs/external/models/application_flow_update';

export default class EditPiiController extends Controller {
  @service currentApplicationFlow;
  @service addressValidation;
  @service router;

  @action async onUpdateIndividual(individualUpdate) {
    try {
      if (!this.addressValidation.didShowIndividualValidation) {
        await this.addressValidation.validateAndStandardizeIndividual(
          individualUpdate.address
        );
      }

      let hasSignificantChanges = false;

      const applicationFlowUpdate = new ApplicationFlowUpdate.Builder()
        .id(this.currentApplicationFlow.id)
        .individual(individualUpdate)
        .build();

      if (
        !this.addressValidation.individualFailedValidation &&
        !this.addressValidation.didShowIndividualValidation
      ) {
        applicationFlowUpdate.individual.address =
          this.addressValidation.individualStandardizedAddress;
        hasSignificantChanges = this.addressValidation.hasSignificantChanges(
          this.addressValidation.individualStandardizationChanges
        );
      }

      await this.currentApplicationFlow.update(applicationFlowUpdate);

      if (
        this.addressValidation.individualFailedValidation &&
        !this.addressValidation.didShowIndividualValidation
      ) {
        set(this, 'addressValidation.didShowIndividualValidation', true);
        this.router.transitionTo('signup.confirm-identity.invalid-address');
      } else if (hasSignificantChanges) {
        set(this, 'addressValidation.didShowIndividualValidation', true);

        this.router.transitionTo('signup.confirm-identity.address');
      } else {
        this.router.transitionTo('signup.confirm-identity');
      }
    } catch (error) {
      this.send('handleRpcError', error);
    }
  }
}
